import { render } from "./AppleKeyboardCaps.vue?vue&type=template&id=63442716"
import script from "./AppleKeyboardCaps.vue?vue&type=script&lang=js"
export * from "./AppleKeyboardCaps.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/AppleKeyboardCaps.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63442716"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63442716', __exports__)) {
    api.reload('63442716', __exports__)
  }
  
  module.hot.accept("./AppleKeyboardCaps.vue?vue&type=template&id=63442716", () => {
    api.rerender('63442716', render)
  })

}


export default __exports__